'use strict';

import ReactDOM from 'react-dom';
import React ,{Component} from 'react';

import 'css/screen.css';

const e = React.createElement;
const envisionIcon = '/assets/img/envision-white-on-dark.svg';


export default class FooterContainer extends Component {
  constructor(props) {
    super(props);
  }

  getCurrentYear(){
    // Return today's date and time
    let currentTime = new Date();
    return currentTime.getFullYear();
  }

  render() {
    return (
<div style={{position: 'relative',paddingTop: '2vw',paddingBottom: '3vw',color: 'rgb(255,255,255)',background: 'rgb(65,65,56)',display:'flex',position: 'relative',paddingLeft:'1.8rem',paddingRight:'1.8rem',flexDirection:'row',justifyContent:'space-between'}}>
          <div>
            <div style={{marginRight:'20px',marginBottom: '30px',marginTop: '5px',}}>
              <img src={envisionIcon}
                  style={{maxWidth:'67px',marginTop:'4px',opacity:'0.7'}}></img>
            </div>
          
            <div style={{color: 'rgba(255,255,255,0.7)'}}>
                <a style={{textDecoration:'none', color:'rgba(255,255,255,0.7)'}} href="http://envision.is">&copy; Envision ehf.{" "+this.getCurrentYear()}</a>
            </div>
            <div style={{color: 'rgba(255,255,255,0.7)'}}>
              Kt: 700616 0100
            </div>
            <div style={{color: 'rgba(255,255,255,0.7)'}}>
              Vsk nr: 133874
            </div>
            <div style={{color: 'rgba(255,255,255,0.7)'}}>
              Sími: 621 5000
            </div>
        </div>

            
          
        <div>
          <div>
            <a style={{textDecoration:'none', color: 'rgba(255,255,255,0.7)'}} href="/personuverndarstefna">Persónuverndarstefna</a>
          </div>
          <div>
            <a style={{textDecoration:'none',color: 'rgba(255,255,255,0.7)'}}  href="/vefkokur">Notkun á vefkökum</a>
          </div>
        </div>
    </div>
    );    
  }

}


// This code renders the Navigation in place ;) from site-nav.hbr
const domContainer = document.getElementById('footer_container');
domContainer ? ReactDOM.render( React.createElement(FooterContainer) , domContainer) : false;


const containerStyle = {
  display:'flex',  
  position: 'relative',
  marginLeft:'1.8rem',
  marginRight:'1.8rem',
  flexDirection:'row',
  justifyContent:'space-between', 
};

const logoStyle = {
  marginRight:'20px',
  marginBottom: '30px',
  marginTop: '5px',
};


const textLineStyle = {
  color: 'rgba(255,255,255,0.7)',
};
